export * from "./MainNavigation";
export { addMegaMenuTranslations } from "./MegaMenu";

import { MainNavigation } from "./MainNavigation";

export default MainNavigation;
